/* */
/**
 * @module actions/Dropdown
 */

import actions from '../constants/ViewActions';

export function openDropdown(dropdownConfiguration) {
  return {
    type: actions.OPEN_DROPDOWN,
    dropdownConfiguration: [dropdownConfiguration.menuType, dropdownConfiguration.config],
  };
}

export function closeDropdown() {
  return {
    type: actions.CLOSE_DROPDOWN,
  };
}
